// extracted by mini-css-extract-plugin
export var circle = "_fj-1";
export var exitConfirmationModal = "_fj-5";
export var iframe = "_fj-0";
export var offline = "_fj-3";
export var online = "_fj-2";
export var workstationSelectError = "_fj-4";